import { render, staticRenderFns } from "./csr_open_orders.vue?vue&type=template&id=7ef9d351&scoped=true&"
import script from "./csr_open_orders.vue?vue&type=script&lang=js&"
export * from "./csr_open_orders.vue?vue&type=script&lang=js&"
import style0 from "./csr_open_orders.vue?vue&type=style&index=0&id=7ef9d351&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef9d351",
  null
  
)

export default component.exports